"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attributes = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

exports.attributes = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Attributes($id: ID!, $channel: String) {\n    attributes(channel: $channel, filter: { inCategory: $id }, first: 100) {\n      edges {\n        node {\n          id\n          name\n          slug\n          choices(first: 100) {\n            edges {\n              node {\n                id\n                name\n                slug\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));